export default __webpack_public_path__ + "static/launch-partner_misang_left@2x-e83635841f11f34fafbca8810f49c66c.jpg";